import React, { useState } from "react";
import { UserCheck, BookOpen, Globe, Calendar } from "lucide-react";
import "./FacultySection.css";

const facultyData = [
  {
    id: 1,
    name: "Dr. Ayesha Khan",
    subject: "Polity",
    experience: 12,
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: 2,
    name: "Prof. Rajesh Sharma",
    subject: "History",
    experience: 10,
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    id: 3,
    name: "Neha Verma",
    subject: "Geography",
    experience: 8,
    image: "https://randomuser.me/api/portraits/women/65.jpg",
  },
  {
    id: 4,
    name: "Anil Gupta",
    subject: "Economics",
    experience: 15,
    image: "https://randomuser.me/api/portraits/men/41.jpg",
  },
  {
    id: 5,
    name: "Sonia Mehta",
    subject: "Environment",
    experience: 7,
    image: "https://randomuser.me/api/portraits/women/22.jpg",
  },
];

const subjects = ["All", "Polity", "History", "Geography", "Economics", "Environment"];

export default function FacultySection() {
  const [selectedSubject, setSelectedSubject] = useState("All");

  const filteredFaculty =
    selectedSubject === "All"
      ? facultyData
      : facultyData.filter((f) => f.subject === selectedSubject);

  return (
    <section className="faculty-section-container">
      <header className="faculty-section-header">
        <h2>Our Expert Faculty</h2>
        <p>Choose your subject expert and get guidance from the best minds.</p>
      </header>

      <div className="faculty-section-filters" role="list" aria-label="Filter faculty by subject">
        {subjects.map((subj) => (
          <button
            key={subj}
            className={`faculty-section-filter-btn ${
              selectedSubject === subj ? "active" : ""
            }`}
            onClick={() => setSelectedSubject(subj)}
            aria-pressed={selectedSubject === subj}
          >
            {subj}
          </button>
        ))}
      </div>

      <div className="faculty-section-grid" role="list">
        {filteredFaculty.map((faculty) => (
          <article key={faculty.id} className="faculty-section-card" role="listitem" tabIndex={0}>
            <div className="faculty-section-img-wrapper">
              <img
                src={faculty.image}
                alt={`${faculty.name} - ${faculty.subject} expert`}
                className="faculty-section-img"
                loading="lazy"
              />
            </div>
            <div className="faculty-section-info">
              <h3>{faculty.name}</h3>
              <p className="faculty-section-subject">
                <BookOpen size={16} /> {faculty.subject}
              </p>
              <p className="faculty-section-experience">
                <Calendar size={16} /> {faculty.experience}+ years experience
              </p>
              <button className="faculty-section-contact-btn" aria-label={`Contact ${faculty.name}`}>
                <UserCheck size={18} /> Contact
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
